// extracted by mini-css-extract-plugin
export default {"labelStatus":"label-status-styles_component_labelStatus__icFmr"};